/* eslint-disable react-hooks/exhaustive-deps */
import { FieldArray, FormikProps, getIn, useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";

import { InterestIncomeOnPF } from "../../../../config/filingConstants";
import { IInterestIncomes } from "../../../../config/interfaces";
import PriceDisplay from "../../../PriceDisplay";
import { NumericInputField, SelectInputField } from "../../../fields";

const OIInterestFromPFForm: React.FC = () => {
  const { values } = useFormikContext<IInterestIncomes>();

  const [sum, setSum] = useState(0);
  const [inputTotal, setInputTotal] = useState<{ [key: string]: number }>({});
  const [currentTime, setCurrentTime] = useState<number>(new Date().getTime());

  useEffect(() => {
    let _sum = 0;
    let _totalInput: { [key: string]: number } = {};
    if (values?.PFIncomes.length) {
      values?.PFIncomes.forEach((item, index) => {
        _totalInput[index] = parseInt(item[1]) || 0;
        if (item.length && item[1]) {
          _sum += parseInt(item[1]) || 0;
        }
      });
      setInputTotal(() => _totalInput);
    }
    setSum(() => _sum);
  }, [currentTime]);

  const handleAmountInc = (amt: number, index: string) => {
    inputTotal[index] = amt;
    setInputTotal(() => inputTotal);
    const _sum = Object.values(inputTotal).reduce((a, b) => Number(a) + Number(b), 0);
    setSum(() => _sum);
  };

  return (
    <>
      <div className="section-title-wrap">
        <h5>Interest Income on PF</h5>
      </div>
      <Card className="more-info-card shadow-none mb-5">
        <Card.Header>
          <Card.Title>PF Income</Card.Title>
        </Card.Header>
        <Card.Body>
          <section>
            <FieldArray name="PFIncomes">
              {({ push, replace, remove, form }) => (
                <>
                  {values?.PFIncomes && values?.PFIncomes?.length > 0
                    ? values?.PFIncomes.map((_, index) => (
                        <section key={`salary-allowance-${index}`}>
                          <PFIncomesForm
                            index={index}
                            form={form}
                            onRemove={(itemIdx: number) => {
                              if (values.PFIncomes.length === 1) {
                                replace(itemIdx, ["", ""]);
                              } else {
                                remove(itemIdx);
                              }

                              setCurrentTime(new Date().getTime());
                            }}
                            handleAmountInc={handleAmountInc}
                          />
                        </section>
                      ))
                    : null}
                  {/* <PreventEditComponent>
                    <Button variant="link" className="btn-add-link" onClick={() => push(["", ""])}>
                      <FASvgIcon icon={faCirclePlus} />
                      Add more
                    </Button>
                  </PreventEditComponent> */}
                </>
              )}
            </FieldArray>
          </section>
        </Card.Body>
        <Card.Footer>
          <p className="total-content">
            <span className="total-label">Total:</span>
            <span className="total-amount">
              <PriceDisplay price={sum} />
            </span>
          </p>
        </Card.Footer>
      </Card>
    </>
  );
};

export default OIInterestFromPFForm;

type PFIncomesProps = {
  index: number;
  form: FormikProps<IInterestIncomes>;
  onRemove: (itemIdx: number) => void;
  handleAmountInc: (amt: number, index: string) => void;
};

const PFIncomesForm: React.FC<PFIncomesProps> = (props: PFIncomesProps) => {
  const { index, onRemove, form, handleAmountInc } = props;

  const { setFieldValue, handleBlur, values, touched, errors } = form;

  return (
    <>
      <Row className="align-items-center">
        <Col sm={6}>
          <SelectInputField
            placeholder="Select other"
            name={`PFIncomes.${index}[0]`}
            label="Type"
            isOptionArrayOfObject={false}
            options={InterestIncomeOnPF}
            value={[values.PFIncomes[index][0]]}
            onChange={(selectedStatus) => {
              if (selectedStatus) {
                setFieldValue(`PFIncomes.${index}[0]`, selectedStatus.value);
              } else {
                setFieldValue(`PFIncomes.${index}[0]`, undefined);
              }
            }}
            onBlur={handleBlur(`PFIncomes.${index}[0]`)}
            containerClasses={
              Boolean(getIn(errors, `PFIncomes.${index}[0]`)) &&
              getIn(touched, `PFIncomes.${index}[0]`)
            }
            errorMsg={getIn(errors, `PFIncomes.${index}[0]`)}
          />
        </Col>
        <Col sm>
          <NumericInputField
            showLeftIcon={true}
            placeholder=""
            name={`PFIncomes.${index}[1]`}
            label="Amount"
            value={values.PFIncomes[index][1]}
            onBlur={handleBlur(`PFIncomes.${index}[1]`)}
            onChange={(value) => {
              setFieldValue(`PFIncomes.${index}[1]`, value);
              setTimeout(() => {
                handleAmountInc(Number(value), String(index));
              }, 100);
            }}
            isInvalid={
              Boolean(getIn(errors, `PFIncomes.${index}[1]`)) &&
              getIn(touched, `PFIncomes.${index}[1]`)
            }
            errorMsg={getIn(errors, `PFIncomes.${index}[1]`)}
          />
        </Col>
        {/* <PreventEditComponent>
          <Col sm={"auto"} className="ps-0">
            <Button
              variant="transparent"
              className="text-greyDark icon-only d-none d-sm-flex"
              onClick={() => onRemove(index)}
            >
              <FASvgIcon icon={faTrash} />
            </Button>
            <Button
              variant="transparent"
              className="btn-delete-full d-sm-none"
              onClick={() => onRemove(index)}
            >
              <FASvgIcon icon={faTrash} />
              <span>Delete</span>
            </Button>
          </Col>
        </PreventEditComponent> */}
      </Row>
      {index !== values.PFIncomes.length - 1 && <hr className="d-block d-sm-none my-4" />}
    </>
  );
};
